;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { waitForTourTarget } from "@/features/onboarding-tours/orchestrator/wait-for-tour-target";

export function scrollTourTargetIntoView({ target }: { target: string }): void {
	const element = document.querySelector(target);
	if (!(element instanceof HTMLElement)) {
		return;
	}

	element.scrollIntoView({
		behavior: "smooth",
		block: "center",
		inline: "nearest",
	});
}

/** Wait until the target is in the DOM/visible, then scroll it into view. */
export async function scrollTourTargetIntoViewWhenReady({
	target,
	signal,
}: {
	target: string;
	signal?: AbortSignal;
}): Promise<void> {
	if (signal?.aborted) {
		return;
	}

	const isReady = await waitForTourTarget({ signal, target });
	if (signal?.aborted || !isReady) {
		return;
	}

	scrollTourTargetIntoView({ target });
}
